export default {"src":"/_next/static/media/lbsLending.faccd190.svg","height":107,"width":385,"blurWidth":0,"blurHeight":0};